<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/custom-event-name-casing */
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineEmits(['logo-change']);

const model = defineModel({
  type: Object,
  required: true,
});

const inputClass =
  'w-full rounded-lais border border-lais-border px-3 py-2 text-[14px] bg-white';
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Identificação">
    <div class="grid gap-3 md:grid-cols-2">
      <LaisField label="Nome da imobiliária">
        <input v-model="model.name" :class="inputClass" />
      </LaisField>
      <LaisField label="Região de atuação">
        <input v-model="model.region" :class="inputClass" />
      </LaisField>
      <LaisField label="Endereço completo">
        <input v-model="model.address" :class="inputClass" />
      </LaisField>
      <LaisField label="Site">
        <input v-model="model.site" :class="inputClass" />
      </LaisField>
      <LaisField label="Horários de funcionamento">
        <input v-model="model.business_hours" :class="inputClass" />
      </LaisField>
      <LaisField label="Logo da imobiliária">
        <div class="flex items-center gap-3">
          <img
            v-if="model.logo"
            :src="model.logo"
            alt="Logo da imobiliária"
            class="size-14 rounded-lais border border-lais-border object-cover"
          />
          <input
            type="file"
            accept="image/*"
            class="text-[13px]"
            @change="$emit('logo-change', $event)"
          />
        </div>
      </LaisField>
    </div>
  </LaisCard>
</template>
